import React, { useEffect, useState } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { resolveGoogleClientId, shouldUseNativeGoogleSignIn } from '../../lib/googleAuth';

/**
 * Wraps the app with GoogleOAuthProvider on web when a client id is available.
 * Native apps use @capgo/capacitor-social-login instead of the web GIS button.
 */
export default function GoogleAuthShell({ children }) {
  const envId = (process.env.REACT_APP_GOOGLE_CLIENT_ID || '').trim();
  const [clientId, setClientId] = useState(envId);

  useEffect(() => {
    if (envId) return;
    // Resolve from backend for OTA / Netlify builds (web + native).
    void resolveGoogleClientId().then((id) => {
      if (id) setClientId(id);
    });
  }, [envId]);

  if (clientId && !shouldUseNativeGoogleSignIn()) {
    return <GoogleOAuthProvider clientId={clientId}>{children}</GoogleOAuthProvider>;
  }
  return children;
}
